import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from "../service/auth.service";

@Injectable({providedIn: 'root'})
export class NoAuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(): boolean {
    if (!this.auth.getUser()) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
